module.exports = __webpack_public_path__ + "img/custom.c74ad7f8.png";